<form no-validate (ngSubmit)="onSubmit(form)" [formGroup]="form">
    <ng-container *ngFor="let part of objectKeys(config);">
        <ng-container *ngIf="config[part].hasGroup || config[part].hasTemplate">
            <ng-container [ngTemplateOutlet]="this[part]" [ngTemplateOutletContext]="{ info: config[part] }"></ng-container>
        </ng-container>
    </ng-container>
</form>

<ng-template #remark let-info="info">
    <div class="ctn">
        <remark-fieldset [group]="form.controls.remark" [config]="info"></remark-fieldset>
    </div>
</ng-template>
